import {useCallback, useRef} from 'react';

export const useCallbackDelayed = <Params extends any[]>(
  callback: (...args: Params) => void,
  delay: number,
) => {
  const timeoutRef = useRef<number | null>(null);

  const delayedCallback = useCallback(
    (...args: Params) => {
      if (timeoutRef.current) {
        window.clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = window.setTimeout(() => {
        // eslint-disable-next-line n/no-callback-literal
        callback(...args);
      }, delay);
    },
    [callback, delay],
  );

  const cancelCallback = useCallback(() => {
    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current);
    }
  }, []);

  return {
    delayedCallback,
    cancelCallback,
  };
};
